import { render, staticRenderFns } from "./OutboundDetail.vue?vue&type=template&id=5b4a41a3&scoped=true"
import script from "./OutboundDetail.vue?vue&type=script&lang=js"
export * from "./OutboundDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a41a3",
  null
  
)

export default component.exports